import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Mail, CalendarClock } from "lucide-react";
import { useBooking } from "../BookingContext";
import { BOOKING_URLS, mailto } from "../content";

export const BookingModal = ({ t }) => {
  const { open, setOpen, type } = useBooking();
  const isKids = type === "kids";
  const title = isKids ? t.booking.titleKids : t.booking.titleAdults;
  const subject = isKids ? t.cta.kidsSubject : t.cta.adultsSubject;
  const baseUrl = isKids ? BOOKING_URLS.kids : BOOKING_URLS.adults;
  const calendarSrc = baseUrl
    ? `${baseUrl}?hide_gdpr_banner=1&background_color=ffffff&primary_color=0066ff`
    : "";

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="max-w-3xl overflow-hidden rounded-3xl border-black/10 p-0"
        data-testid="booking-modal"
      >
        <DialogHeader className="border-b border-black/10 bg-[#FAFAFA] px-6 py-5 text-left">
          <DialogTitle className="flex items-center gap-2 font-display text-2xl font-black tracking-tight text-black">
            <CalendarClock className="h-6 w-6 text-[#0066FF]" />
            {title}
          </DialogTitle>
          <DialogDescription className="mt-1 text-sm text-black/60">
            {t.booking.desc}
          </DialogDescription>
        </DialogHeader>

        {calendarSrc ? (
          <div className="h-[640px] w-full bg-white">
            <iframe
              src={calendarSrc}
              title="Booking calendar"
              className="h-full w-full border-0"
              data-testid="booking-calendar-iframe"
            />
          </div>
        ) : (
          <div className="flex flex-col items-center gap-6 px-6 py-12 text-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#0066FF]/10">
              <CalendarClock className="h-8 w-8 text-[#0066FF]" />
            </div>
            <p className="max-w-md text-base text-black/70" data-testid="booking-fallback-message">
              {t.booking.notConfigured}
            </p>
            <a
              href={mailto(subject, t.cta.mailBody)}
              data-testid="booking-email-button"
              className="inline-flex items-center gap-2 rounded-full bg-[#FF6B00] px-8 py-4 text-base font-bold text-white shadow-[0_8px_0_0_#c85400] transition-all hover:-translate-y-0.5 hover:shadow-[0_10px_0_0_#c85400]"
            >
              <Mail className="h-5 w-5" />
              {t.booking.emailButton}
            </a>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
